import { useCallback, useRef, useState } from "react";
import { IOmniaSession, IOmniaShell } from "@omnia/types";
import { IHoldingService } from "../types";
import { str } from "@omnia/shared/strings";
import { ReactAngularComponentContext } from "@omnia/shared/react/angular";
import { AngularReactDialog } from "@omnia/shared/react/reactAngularDialog";
import { DialogBody } from "@omnia/shared/react/DialogBody";
import { DialogFooter } from "@omnia/shared/react/DialogFooter";
import { DialogHeader } from "@omnia/shared/react/DialogHeader";
import { Msg } from "@omnia/shared/react/Msg";
import { HoldingEditComponent, HoldingEditComponentHandle } from "./HoldingEditComponent";

export const ReactHoldingEditDialog: AngularReactDialog = {

    inject: {
        shell: "OmniaShell",
        session: "OmniaSession",
        holdingSvc: "OmniaHoldingService"
    },

    component: HoldingEditDialog
}

export function HoldingEditDialog({ 
    dependencies, 
    arguments: args, 
    close,
    }: ReactAngularComponentContext) {

    const shell: IOmniaShell = dependencies["shell"];
    const session: IOmniaSession = dependencies["session"];
    const holdingSvc: IHoldingService = dependencies["holdingSvc"];

    const editorRef = useRef<HoldingEditComponentHandle>();
    const [canSave, setCanSave] = useState<boolean>(false);

    const handleIsValidChange = useCallback((isValid: boolean) => {
        setCanSave(isValid);
    }, []);

    return (
        <div className="omnia-holding-edit-dialog">
            <DialogHeader>
                <Msg text={`${str.Edit} ${args?.holding ? args.holding.TradingName : '' }`} />
            </DialogHeader>
            <DialogBody>
                <HoldingEditComponent 
                    ref={editorRef}
                    shell={shell} 
                    session={session} 
                    holdingService={holdingSvc}
                    holding={args?.holding}
                    onIsValidChange={handleIsValidChange}
                />
                {/* <omnia-holding-edit holding="vm.holding" context="vm.context"></omnia-holding-edit> */}
            </DialogBody>
            <DialogFooter>
                <button className="btn btn-warning" type="button" 
                    onClick={() => close(false)}
                    >
                    Cancel
                </button>
                <button className="btn btn-success" type="button" 
                    disabled={!canSave}
                    onClick={() => editorRef.current?.saveHolding().then(() => close(true))}
                    >
                    Save
                </button>
            </DialogFooter>
        </div>
    );
}